<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "AdminPanel"
    }
</script>

<style scoped>

</style>